(function () {
  window.dataLayer = window.dataLayer || [];

  function bdTrack(name, params) {
    var payload = Object.assign({ event: name }, params || {});
    window.dataLayer.push(payload);
    try {
      if (window.location.search.indexOf('bd_debug=1') !== -1) {
        console.log('[bd-track]', payload);
      }
    } catch (e) {}
  }
  window.bdTrack = bdTrack;

  // Generieke delegatie voor alles met data-bd-event="..."
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-bd-event]');
    if (!el) return;
    bdTrack(el.getAttribute('data-bd-event'), {
      label: (el.textContent || '').trim().slice(0, 80),
      path: window.location.pathname
    });
  });

  // Keuzehulp-interacties (apparaat/model/maat stappen) binnen #keuzehulp
  document.addEventListener('click', function (e) {
    var keuzehulp = e.target.closest('#keuzehulp');
    if (!keuzehulp) return;
    var link = e.target.closest('a, button');
    if (!link || link.hasAttribute('data-bd-event')) return;
    var label = (link.textContent || '').trim().slice(0, 80);
    if (!label) return;
    bdTrack('bd_keuzehulp_interaction', { label: label, path: window.location.pathname });
  });

  // Add-to-cart (dekt zowel de normale als de sticky-positie knop, want het is dezelfde form)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
    if (!form) return;
    bdTrack('bd_add_to_cart_click', { path: window.location.pathname });
  });
})();
